import { pick, omitBy, isUndefined } from 'lodash';
const sharedFieldNames = ['city', 'subdivision', 'country', 'postalCode'];
const sharedStreetAddressFieldNames = ['name', 'number', 'apt'];
const p13nToCorvid = (p13nAddress) => p13nAddress
    ? omitBy({
        formatted: p13nAddress.formattedAddress,
        location: p13nAddress.geocode,
        ...pick(p13nAddress, sharedFieldNames),
        streetAddress: p13nAddress.streetAddress &&
            pick(p13nAddress.streetAddress, sharedStreetAddressFieldNames),
        addressLine1: p13nAddress.addressLine,
        addressLine2: p13nAddress.addressLine2,
    }, isUndefined)
    : undefined;
const corvidToP13n = (corvidAddress) => corvidAddress
    ? omitBy({
        formattedAddress: corvidAddress.formatted,
        geocode: corvidAddress.location,
        ...pick(corvidAddress, sharedFieldNames),
        streetAddress: corvidAddress.streetAddress &&
            pick(corvidAddress.streetAddress, sharedStreetAddressFieldNames),
        addressLine: corvidAddress.addressLine1,
        addressLine2: corvidAddress.addressLine2,
    }, isUndefined)
    : undefined;
export { p13nToCorvid, corvidToP13n };
//# sourceMappingURL=index.js.map